import styled from 'styled-components'

export const Container = styled.header`
  margin: 0 1rem;
  padding: 0;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
`

export const HeaderWrapper = styled.div`
  display: flex;
  img {
    width: 150px;
    height: 150px;
    border-radius: 50%;
  }

  display: flex;
  justify-content: space-between;
  align-items: center;

  div {
    width: 120px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`

export const ImageAvatar = styled.div`
  display: flex;
  /* justify-content: center; */
  flex-direction: column;

  svg {
    position: relative;
    background-color: #808080;
    padding: 5px;
    border-radius: 50%;
    color: white;
    bottom: 2rem;
    left: 3rem;
    cursor: pointer;
    margin-bottom: -1.9rem;
  }
`
